export const countTextHeight = () => {
  const textElements = document.querySelectorAll('.cooperation__text');

  if (textElements.length > 0) {
    let maxHeight = 0;

    textElements.forEach((text) => {
      const { height } = text.getBoundingClientRect();
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    textElements.forEach((text) => {
      text.style.height = `${maxHeight}px`;
    });
  }
};
